
export const uniqueID = () => {
	const chr4 = () => {
		return Math.random().toString(16).slice(-4);
	};

	return chr4() + chr4() +
		'-' + chr4() +
		'-' + chr4() +
		'-' + chr4() +
		'-' + chr4() + chr4() + chr4();
}

export const updateConsent = (userCookie, userConsentCookie, eventValue) => {
	/* EP-864 Wrong values are being sent */
	/*
	var googlePostMetric =  {
		"v": 1,                                         // Version
		"tid": process.env.GATSBY_USER_CONSENT_TID,     // Tracking ID / Property ID.
		"cid": userCookie,                 				 // Anonymous Client ID.
		"t": "event",                                   // Event hit type
		"ec": "cookie-consent",                         // Event Category. Required.
		"ea": userCookie,							    // Event Action. Required //cookie-name.
		"el": userConsentCookie,                        // Event label. //consent-value
		"ev": eventValue,                               // event value consent value accept = 1 or rejcet = 2
		"dl": window.location.href                      // traffic source.
	}


	fetch(process.env.GATSBY_GA_COLLECT, {
		method: 'post',
		body: new URLSearchParams(googlePostMetric)
	})
	.then(response => response.text())
	.then((data) => {
		try {
			data = JSON.parse(data);
		} catch(e) { }
	}); */
} 
